// TODO: split file.
import React from 'react';
import {
  useModalClose,
  useOpenModalOnEvent,
} from '@/features/modals/modalSlice';
import {
  NEW_SAVED_QUERY_SAVED,
  OPEN_EMAIL_ALERT_MODAL,
  OPEN_GOOGLE_SHEETS_EXPORT_MODAL,
  OPEN_SHARE_WITH_TEAM_MODAL,
  OPEN_SLACK_NOTIFICATION_MODAL,
} from '@/constants/custom-event-names';
import { Modal } from '@/features/modals/components';
import styled from 'styled-components';
import { TrevorIcon } from '@trevor/ui-components';
import { dispatchCustomEvent } from '@/util/createCustomEvent';
import { useAppSelector } from '@/store/hooks';

const getAlertsDisabled = (s: any) => s.datasource.alertsDisabled;
const getExportsDisabled = (s: any) => s.datasource.exportsDisabled;
const getFeedsDisabled = (s: any) => s.datasource.feedsDisabled;

export const SavedQueryNextSteps = () => {
  const isOpen = useOpenModalOnEvent(NEW_SAVED_QUERY_SAVED);

  return isOpen ? <NextStepsModal /> : null;
};

const NextStepsModal = () => (
  <Modal noDefaultFooter vPosition="center">
    <ModalContainer>
      <img src="/img/party.png" />
      <h2>Query saved!</h2>
      <StepsContainer>
        <p>Next steps</p>
        <ShareWithTeamOption />
        <GoogleSheetsExportOption />
        <SlackNotificationOption />
        <EmailAlertOption />
      </StepsContainer>
    </ModalContainer>
  </Modal>
);

const ShareWithTeamOption = () => {
  const handleClose = useModalClose();

  const handleClick = () => {
    handleClose();
    dispatchCustomEvent(OPEN_SHARE_WITH_TEAM_MODAL);
  };

  return (
    <button onClick={handleClick}>
      <TrevorIcon name="link" />
      Share with your team
      <TrevorIcon name="chevron-right" />
    </button>
  );
};

const GoogleSheetsExportOption = () => {
  const exportsDisabled = useAppSelector(getExportsDisabled);
  const feedsDisabled = useAppSelector(getFeedsDisabled);
  const handleClose = useModalClose();

  const handleClick = () => {
    handleClose();
    dispatchCustomEvent(OPEN_GOOGLE_SHEETS_EXPORT_MODAL);
  };

  const disabled = exportsDisabled || feedsDisabled;

  return (
    <button disabled={disabled} onClick={handleClick}>
      <TrevorIcon name="google-sheets" />
      Export the live results to Google Sheets
      <TrevorIcon name="chevron-right" />
    </button>
  );
};

const SlackNotificationOption = () => {
  const alertsDisabled = useAppSelector(getAlertsDisabled);
  const feedsDisabled = useAppSelector(getFeedsDisabled);
  const handleClose = useModalClose();

  const handleClick = () => {
    handleClose();
    dispatchCustomEvent(OPEN_SLACK_NOTIFICATION_MODAL);
  };

  const disabled = alertsDisabled || feedsDisabled;

  return (
    <button disabled={disabled} onClick={handleClick}>
      <TrevorIcon name="slack" />
      Notify a Slack channel with new results
      <TrevorIcon name="chevron-right" />
    </button>
  );
};

const EmailAlertOption = () => {
  const alertsDisabled = useAppSelector(getAlertsDisabled);
  const feedsDisabled = useAppSelector(getFeedsDisabled);
  const handleClose = useModalClose();

  const handleClick = () => {
    handleClose();
    dispatchCustomEvent(OPEN_EMAIL_ALERT_MODAL);
  };

  const disabled = alertsDisabled || feedsDisabled;

  return (
    <button disabled={disabled} onClick={handleClick}>
      <TrevorIcon name="mail" />
      Get an Email alert when results change
      <TrevorIcon name="chevron-right" />
    </button>
  );
};

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 60px;

  > img {
    width: 40px;
    height: 40px;
  }

  > h2 {
    font-size: 25px;
    font-weight: 700;
    margin-top: 20px;
    margin-bottom: 10px;
  }
`;

const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 420px;
  margin-top: 20px;

  > button {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: transparent;
    border: 1px solid #ddd;
    outline: none;
    gap: 15px;

    :not(:first-of-type) {
      border-top: none;
    }

    :first-of-type {
      border-top-right-radius: var(--radius-4);
      border-top-left-radius: var(--radius-4);
    }

    :last-of-type {
      border-bottom-right-radius: var(--radius-4);
      border-bottom-left-radius: var(--radius-4);
    }

    :not(:disabled):hover {
      background-color: #fafafa;
    }

    > svg:last-of-type {
      margin-left: auto;
    }
  }
`;
